// Copy from MT-Common-Vue, ./utils/fetchLocal.js
export default function fetchLocal(url, responseType) {
    return new Promise(function(resolve, reject) {
        let xhr = new XMLHttpRequest();
        if (responseType) {
            xhr.onloadstart = function() {
                xhr.responseType = responseType;
            };
        }
        xhr.onload = function() {
            if (xhr.status === 200) {
                resolve(xhr.response);
            } else {
                reject(new TypeError('Local request failed'));
            }
        };
        xhr.onerror = function() {
            reject(new TypeError('Local request failed'));
        };
        xhr.open('GET', url);
        xhr.send(null);
    });
}
